import styled from "styled-components";

export const StyledFooter = styled.div`
  position: relative;
  text-align: center;
  color: white;
  width: 100%;
  top: 15vh;
  font-size: 15px;
  background: rgb(54, 53, 53);
  padding: 40px 30px;
  box-sizing: border-box;
`;
